import React from 'react';
import { Typography, Box, Link } from '@material-ui/core';
import { LegalPageLayout, useLegalStyles } from './LegalPageLayout';

export const PrivacyPolicy: React.FC = () => {
  const classes = useLegalStyles();

  return (
    <LegalPageLayout title="Informativa sulla Privacy" lastUpdate="11 dicembre 2024">
      <Box className={classes.section}>
        <Typography variant="h5" className={classes.sectionTitle}>
          1. Titolare del Trattamento
        </Typography>
        <Typography className={classes.paragraph}>Il Titolare del trattamento dei dati personali è:</Typography>
        <Typography className={classes.paragraph}>
          <strong>Società Agricola L'orto Dei F.lli Compagnoni S.s.</strong>
          <br />
          Via Baccanina, 2 - 41037 Mirandola (MO)
          <br />
          P.IVA: 03824940369
          <br />
          Telefono: 339 540 8713
          <br />
          Email: negozio@lortocompagnoni.it
        </Typography>
      </Box>

      <Box className={classes.section}>
        <Typography variant="h5" className={classes.sectionTitle}>
          2. Tipologia di Dati Raccolti
        </Typography>
        <Typography className={classes.paragraph}>
          Nel corso della navigazione e dell'utilizzo dei servizi offerti, raccogliamo le seguenti categorie di dati
          personali:
        </Typography>

        <Typography variant="h6" gutterBottom style={{ marginTop: 16 }}>
          2.1 Dati di Registrazione e Acquisto
        </Typography>
        <ul className={classes.list}>
          <li>Nome e cognome</li>
          <li>Indirizzo email</li>
          <li>Numero di telefono</li>
          <li>Indirizzo di consegna (via, città, CAP, provincia)</li>
          <li>Codice partner (opzionale)</li>
        </ul>

        <Typography variant="h6" gutterBottom>
          2.2 Dati di Navigazione
        </Typography>
        <Typography className={classes.paragraph}>
          I sistemi informatici preposti al funzionamento del sito acquisiscono, nel corso del loro normale esercizio,
          alcuni dati personali la cui trasmissione è implicita nell'uso dei protocolli di comunicazione Internet. Si
          tratta di informazioni che non sono raccolte per essere associate a interessati identificati, ma che per loro
          stessa natura potrebbero, attraverso elaborazioni ed associazioni con dati detenuti da terzi, permettere di
          identificare gli utenti.
        </Typography>

        <Typography variant="h6" gutterBottom>
          2.3 Dati di Pagamento
        </Typography>
        <Typography className={classes.paragraph}>
          I dati relativi ai pagamenti (numero carta di credito, dati bancari) sono gestiti direttamente da Stripe Inc.,
          nostro fornitore di servizi di pagamento certificato PCI-DSS. Non conserviamo mai i dati completi della carta
          di credito sui nostri server.
        </Typography>
      </Box>

      <Box className={classes.section}>
        <Typography variant="h5" className={classes.sectionTitle}>
          3. Finalità del Trattamento
        </Typography>
        <Typography className={classes.paragraph}>I dati personali sono trattati per le seguenti finalità:</Typography>
        <ul className={classes.list}>
          <li>
            <strong>Esecuzione contrattuale (Art. 6.1.b GDPR):</strong> gestione degli ordini, consegna dei prodotti,
            fatturazione, gestione del rapporto cliente, assistenza post-vendita.
          </li>
          <li>
            <strong>Obblighi di legge (Art. 6.1.c GDPR):</strong> adempimento di obblighi fiscali, contabili e
            amministrativi previsti dalla normativa vigente.
          </li>
          <li>
            <strong>Legittimo interesse (Art. 6.1.f GDPR):</strong> prevenzione frodi, sicurezza informatica,
            monitoraggio errori tecnici, miglioramento dei servizi.
          </li>
          <li>
            <strong>Consenso (Art. 6.1.a GDPR):</strong> invio di comunicazioni promozionali relative ai nostri prodotti
            biologici, offerte speciali e novità aziendali (solo se espressamente autorizzato).
          </li>
        </ul>
      </Box>

      <Box className={classes.section}>
        <Typography variant="h5" className={classes.sectionTitle}>
          4. Base Giuridica del Trattamento
        </Typography>
        <Typography className={classes.paragraph}>
          Il trattamento dei dati personali si fonda sulle seguenti basi giuridiche:
        </Typography>
        <ul className={classes.list}>
          <li>Necessità contrattuale per l'esecuzione di un contratto di vendita</li>
          <li>Adempimento di obblighi legali</li>
          <li>Consenso dell'interessato per finalità di marketing</li>
          <li>Legittimo interesse per la sicurezza e il miglioramento dei servizi</li>
        </ul>
      </Box>

      <Box className={classes.section}>
        <Typography variant="h5" className={classes.sectionTitle}>
          5. Periodo di Conservazione
        </Typography>
        <Typography className={classes.paragraph}>
          I dati personali saranno conservati per i seguenti periodi:
        </Typography>
        <ul className={classes.list}>
          <li>
            <strong>Dati contrattuali:</strong> per tutta la durata del rapporto contrattuale e per i 10 anni successivi
            alla cessazione, in conformità agli obblighi fiscali e contabili.
          </li>
          <li>
            <strong>Dati di navigazione:</strong> fino a 24 mesi dalla raccolta.
          </li>
          <li>
            <strong>Dati per marketing:</strong> fino alla revoca del consenso o comunque non oltre 24 mesi dall'ultimo
            contatto.
          </li>
        </ul>
      </Box>

      <Box className={classes.section}>
        <Typography variant="h5" className={classes.sectionTitle}>
          6. Destinatari dei Dati
        </Typography>
        <Typography className={classes.paragraph}>I dati personali potranno essere comunicati a:</Typography>
        <ul className={classes.list}>
          <li>
            <strong>Corrieri e servizi di spedizione:</strong> per la consegna degli ordini (per ordini con spedizione
            nazionale).
          </li>
          <li>
            <strong>Stripe Inc.:</strong> per l'elaborazione dei pagamenti online.
          </li>
          <li>
            <strong>Sentry:</strong> per il monitoraggio degli errori tecnici e la sicurezza del servizio.
          </li>
          <li>
            <strong>Professionisti e consulenti:</strong> commercialista, consulente del lavoro, per gli adempimenti
            fiscali e contabili.
          </li>
          <li>
            <strong>Autorità pubbliche:</strong> quando richiesto dalla legge.
          </li>
        </ul>
      </Box>

      <Box className={classes.section}>
        <Typography variant="h5" className={classes.sectionTitle}>
          7. Trasferimento dei Dati Extra-UE
        </Typography>
        <Typography className={classes.paragraph}>
          Alcuni dei nostri fornitori di servizi (Stripe, Sentry) potrebbero trasferire i dati negli Stati Uniti. Tali
          trasferimenti avvengono sulla base delle Clausole Contrattuali Standard approvate dalla Commissione Europea
          e/o sulla base del Data Privacy Framework UE-USA, garantendo un livello di protezione adeguato ai sensi del
          GDPR.
        </Typography>
      </Box>

      <Box className={classes.section}>
        <Typography variant="h5" className={classes.sectionTitle}>
          8. Diritti dell'Interessato
        </Typography>
        <Typography className={classes.paragraph}>In qualità di interessato, hai il diritto di:</Typography>
        <ul className={classes.list}>
          <li>
            <strong>Accesso (Art. 15 GDPR):</strong> ottenere conferma che sia o meno in corso un trattamento di dati
            personali che ti riguardano.
          </li>
          <li>
            <strong>Rettifica (Art. 16 GDPR):</strong> ottenere la correzione dei dati personali inesatti.
          </li>
          <li>
            <strong>Cancellazione (Art. 17 GDPR):</strong> ottenere la cancellazione dei dati personali (diritto
            all'oblio).
          </li>
          <li>
            <strong>Limitazione (Art. 18 GDPR):</strong> ottenere la limitazione del trattamento.
          </li>
          <li>
            <strong>Portabilità (Art. 20 GDPR):</strong> ricevere i dati in un formato strutturato, di uso comune e
            leggibile da dispositivo automatico.
          </li>
          <li>
            <strong>Opposizione (Art. 21 GDPR):</strong> opporsi al trattamento per motivi connessi alla tua situazione
            particolare.
          </li>
          <li>
            <strong>Revoca del consenso:</strong> revocare in qualsiasi momento il consenso prestato per il trattamento
            per finalità di marketing.
          </li>
        </ul>
        <Typography className={classes.paragraph}>
          Per esercitare questi diritti, puoi contattarci all'indirizzo email negozio@lortocompagnoni.it o scrivendo a:
          Società Agricola L'orto Dei F.lli Compagnoni S.s., Via Baccanina, 2 - 41037 Mirandola (MO).
        </Typography>
      </Box>

      <Box className={classes.section}>
        <Typography variant="h5" className={classes.sectionTitle}>
          9. Diritto di Reclamo
        </Typography>
        <Typography className={classes.paragraph}>
          Hai il diritto di proporre reclamo all'Autorità Garante per la Protezione dei Dati Personali qualora ritenga
          che il trattamento dei tuoi dati violi la normativa vigente:
        </Typography>
        <Typography className={classes.paragraph}>
          <strong>Garante per la Protezione dei Dati Personali</strong>
          <br />
          Piazza Venezia, 11 - 00187 Roma
          <br />
          Email: garante@gpdp.it
          <br />
          PEC: protocollo@pec.gpdp.it
          <br />
          Sito web:{' '}
          <Link href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer">
            www.garanteprivacy.it
          </Link>
        </Typography>
      </Box>

      <Box className={classes.section}>
        <Typography variant="h5" className={classes.sectionTitle}>
          10. Misure di Sicurezza
        </Typography>
        <Typography className={classes.paragraph}>
          Adottiamo misure tecniche e organizzative adeguate per proteggere i dati personali da accessi non autorizzati,
          perdita, distruzione o alterazione. Tra queste misure:
        </Typography>
        <ul className={classes.list}>
          <li>Crittografia SSL/TLS per tutte le trasmissioni di dati</li>
          <li>Autenticazione sicura con token JWT</li>
          <li>Pagamenti gestiti tramite piattaforma certificata PCI-DSS (Stripe)</li>
          <li>Backup regolari dei dati</li>
          <li>Accesso ai dati limitato al personale autorizzato</li>
        </ul>
      </Box>

      <Box className={classes.section}>
        <Typography variant="h5" className={classes.sectionTitle}>
          11. Modifiche all'Informativa
        </Typography>
        <Typography className={classes.paragraph}>
          La presente informativa può essere soggetta a modifiche e integrazioni. Eventuali modifiche sostanziali
          saranno comunicate attraverso il sito web. Ti invitiamo a consultare periodicamente questa pagina per essere
          sempre aggiornato sulle modalità e finalità del trattamento.
        </Typography>
      </Box>
    </LegalPageLayout>
  );
};
